import type { ReactNode } from 'react'

interface Props {
  icon?: ReactNode
  title: string
  body?: string
  action?: ReactNode
}

/** Icon, one line of plain language, one action. */
export function EmptyState({ icon, title, body, action }: Props) {
  return (
    <div className="flex flex-col items-center gap-3 px-5 py-10 text-center text-fg-muted">
      {icon && (
        // A tinted disc, so an empty panel reads as deliberate rather than as
        // content that failed to load.
        <span className="grid size-14 place-items-center rounded-full bg-subtle text-fg-subtle">
          {icon}
        </span>
      )}
      <p className="text-lg font-semibold text-fg">{title}</p>
      {body && <p className="max-w-[44ch] text-sm leading-normal">{body}</p>}
      {action}
    </div>
  )
}
